module.exports = __webpack_public_path__ + "static/media/picture-3@2x.e13d5977.png";